import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import events from '../data/events';

// ==================== ICONS ====================
const ArrowRightIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
  </svg>
);

const ArrowUpRightIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
  </svg>
);

const MapPinIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
  </svg>
);

const PhoneIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-2.896-1.596-5.48-4.18-7.076-7.076l1.293-.97c.362-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
  </svg>
);

const UserGroupIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
  </svg>
);

const CalendarIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
  </svg>
);

const AcademicCapIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
  </svg>
);

const SparklesIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
  </svg>
);

// ==================== INSTAGRAM SECTION ====================

const INSTAGRAM_POSTS = [
  {
    img: '/assets/images/instagram/ig1.jpg',
    href: 'https://www.instagram.com/p/DcbYaaXkZHt/',
    alt: 'A student holds up the book "Flora and the Flamingo" outside Yankee Stadium.',
  },
  {
    img: '/assets/images/instagram/ig2.jpg',
    href: 'https://www.instagram.com/p/DcKegH8EdI2/',
    alt: 'Back to School Jam flyer — Wednesday, September 9, 2026 in the Cold Side Cafeteria.',
  },
  {
    img: '/assets/images/instagram/ig3.jpg',
    href: 'https://www.instagram.com/reel/DcCHrhcRS4f/',
    alt: 'Two students hold an alphabet beach ball for Summer Discoveries — "Learning never takes a vacation."',
  },
  {
    img: '/assets/images/instagram/ig4.jpg',
    href: 'https://www.instagram.com/reel/DbrTzw7xZRI/',
    alt: 'A student plays a hand drum during a music session.',
  },
  {
    img: '/assets/images/instagram/ig5.jpg',
    href: 'https://www.instagram.com/reel/Dblnu7QRuUK/',
    alt: 'A student gives a thumbs up with the book "Flip & Fin" beside a visitor at a DYCD summer program display.',
  },
  {
    img: '/assets/images/instagram/ig6.jpg',
    href: 'https://www.instagram.com/reel/DbWjBySRgm8/',
    alt: 'A student smiles holding the book "Ramona Quimby, Age 8" in front of a classroom bulletin board.',
  },
];

const InstagramSection = () => (
  <section className="py-24 bg-[#0F2240] overflow-hidden relative">
    <div
      className="absolute inset-0 pointer-events-none"
      style={{ background: 'radial-gradient(ellipse 60% 50% at 0% 100%, rgba(197,145,50,0.1) 0%, transparent 60%)' }}
      aria-hidden="true"
    />
    <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">

      {/* Header — solid navy plate so this text isn't read directly against the
          decorative radial-gradient overlay above (same fix as the page heroes) */}
      <div className="text-center mb-14 bg-[#0F2240] py-2">
        <span className="text-school-gold font-bold tracking-[0.2em] uppercase text-xs mb-4 block">Social</span>
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4">
          Life at{' '}
          <a
            href="https://www.instagram.com/ps85bronx/"
            target="_blank"
            rel="noreferrer"
            className="text-school-gold hover:text-white transition-colors underline decoration-school-gold/30 underline-offset-4 hover:decoration-white focus:outline-none focus:ring-2 focus:ring-school-gold rounded"
          >
            @ps85bronx<span className="sr-only"> on Instagram (opens in new window)</span>
          </a>
        </h2>
        <p className="text-white/50 text-base max-w-lg mx-auto">
          Follow our daily adventures, student achievements, and community events on Instagram.
        </p>
      </div>

      {/* Photo grid */}
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
        {INSTAGRAM_POSTS.map((post, i) => (
          <a
            key={i}
            href={post.href}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative block overflow-hidden rounded-2xl aspect-square bg-white/5 focus:outline-none focus:ring-2 focus:ring-school-gold"
            aria-label={`${post.alt} View this post from @ps85bronx on Instagram (opens in new window)`}
          >
            <img
              src={post.img}
              alt=""
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            {/* Hover overlay */}
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
              <svg
                className="w-10 h-10 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 drop-shadow-lg"
                fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"
              >
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
              </svg>
            </div>
          </a>
        ))}
      </div>

      {/* Follow button */}
      <div className="text-center mt-12">
        <a
          href="https://www.instagram.com/ps85bronx/"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-3 bg-[#C13584] text-white px-8 py-4 rounded-full font-bold text-sm hover:scale-105 transition-transform shadow-lg shadow-pink-500/20 focus:outline-none focus:ring-2 focus:ring-pink-400/60"
        >
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
          </svg>
          Follow @ps85bronx
          <span className="sr-only"> on Instagram (opens in new window)</span>
        </a>
      </div>

    </div>
  </section>
);

// ==================== UPCOMING EVENTS ====================

// "Sep 1–3 · 9:00 AM", "Sep 10", "Sep 30 · 4:30 PM"
const formatEventDate = (event) => {
  const opts = { month: 'short', day: 'numeric' };
  let label = event.date.toLocaleDateString('en-US', opts);
  if (event.endDate) label += `–${event.endDate.getDate()}`;
  return event.allDay || !event.startTime ? label : `${label} · ${event.startTime}`;
};

const getUpcomingEvents = (limit = 3) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return events
    .filter((e) => (e.endDate || e.date) >= today)
    .sort((a, b) => a.date - b.date)
    .slice(0, limit);
};

// ==================== MAIN PAGE ====================
const HomePage = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Item 0 is the large "Featured" card, the rest stack above Upcoming Events.
  // When empty, the section shows only the Upcoming Events board.
  const newsArticles = [];

  const quickLinks = [
    { label: 'Staff Directory', href: '/coming-soon', icon: <UserGroupIcon className="w-5 h-5" /> },
    { label: 'Events Calendar', href: '/calendar', icon: <CalendarIcon className="w-5 h-5" /> },
    { label: 'TeachHub', href: 'https://teachhub.schools.nyc/', icon: <AcademicCapIcon className="w-5 h-5" /> },
    { label: 'ClassDojo', href: 'https://www.classdojo.com/', icon: <SparklesIcon className="w-5 h-5" /> },
  ];

  const stats = [
    { num: '700+', label: 'Students Enrolled' },
    { num: '100+', label: 'Dedicated Staff' },
    { num: '90+', label: 'Years of Excellence' },
    { num: 'PK–5', label: 'Grade Levels' },
  ];

  const upcomingEvents = getUpcomingEvents();

  // `eyebrow` and `flyerES` are optional: a bilingual or English-only flyer
  // has just `flyerEN` and shows as a single image.
  const flyerEvents = [
    {
      id: 'election-day',
      eyebrow: 'Important Announcement',
      title: <>Election Day:<br />Remote Learning</>,
      blurb: (
        <>
          November 3 will be a remote day of learning for all students. All students will have access to a school-issued Chromebook for home use. For technology support or password reset, Ms. Berkowitz at{' '}
          <a href="mailto:mberkowitz4@schools.nyc.gov" className="font-semibold text-school-gold underline underline-offset-2 break-words hover:text-white focus:outline-none focus:ring-2 focus:ring-school-gold rounded">mberkowitz4@schools.nyc.gov</a>
          {' '}or Mr. Moore at{' '}
          <a href="mailto:rmoore7@schools.nyc.gov" className="font-semibold text-school-gold underline underline-offset-2 break-words hover:text-white focus:outline-none focus:ring-2 focus:ring-school-gold rounded">rmoore7@schools.nyc.gov</a>.
        </>
      ),
      details: [
        { icon: <CalendarIcon className="w-5 h-5" />, text: 'Tuesday, November 3' },
        { icon: <UserGroupIcon className="w-5 h-5" />, text: 'School in session remotely for all students' },
      ],
      flyerEN: {
        src: '/assets/images/Election_Day_EN.webp',
        alt: 'Election Day: Remote Learning flyer in English — Tuesday, November 3, 2026. School in session remotely for all students. Important announcement for NYC Public Schools families. An illustration of a laptop showing an online class, beside a ballot box and school supplies.',
      },
    },
    {
      id: 'wreath-making',
      eyebrow: 'Parent Workshop',
      title: <>Wreath<br />Making</>,
      blurb: "Join us for a fun and creative parent workshop where you'll learn how to make your own beautiful holiday wreath!",
      details: [
        { icon: <CalendarIcon className="w-5 h-5" />, text: 'Date: November TBD' },
        { icon: <MapPinIcon className="w-5 h-5" />, text: 'Location: PS 85 Great Expectations' },
        { icon: <UserGroupIcon className="w-5 h-5" />, text: 'All Parents Welcome! · All supplies provided!' },
      ],
      flyerEN: {
        src: '/assets/images/Wreath_Making_EN.webp',
        alt: 'Parent Workshop for a Wreath Making flyer — Create, Connect, Celebrate. Join us for a fun and creative parent workshop where you’ll learn how to make your own beautiful holiday wreath! Date: November TBD. Location: PS 85 Great Expectations. All Parents Welcome! All supplies provided! We can’t wait to see you there!',
      },
    },
  ];

  const enrollSteps = [
    { step: '01', title: 'Schedule a Tour', description: 'Reach out to confirm availability. Come see our classrooms in action and meet the faculty.' },
    { step: '02', title: 'Prepare Documents', description: "Gather your child's records. We'll provide a simple checklist to make this seamless." },
    { step: '03', title: 'Submit Registration', description: "Hand in your paperwork to our main office. We'll review it and secure your spot." },
    { step: '04', title: 'Welcome to PS 85', description: 'Receive your start dates, classroom assignments, and join the Great Expectations family!' },
  ];

  return (
    <div
      className="min-h-screen font-sans text-gray-800 selection:bg-school-gold/30 selection:text-school-blue"
      style={{ backgroundColor: '#F5EFE0' }}
    >
      <Navbar />

      <main id="main-content">

        {/* ==================== HERO ==================== */}
        <section className="relative flex h-[100svh] min-h-[560px] w-full flex-col overflow-hidden bg-[#0F2240]">
          {/* Video — no copy sits on the footage any more, so it plays at full
              strength under a gentle top/bottom vignette (the top keeps the
              nav area calm). */}
          <div className="absolute inset-0 w-full h-full">
            <video
              autoPlay loop muted playsInline
              aria-hidden="true"
              className="w-full h-full object-cover"
              style={{ transform: `translateY(${scrollY * 0.25}px) scale(1.08)` }}
            >
              <source src="/assets/videos/home/ps85.mp4" type="video/mp4" />
            </video>
            <div
              aria-hidden="true"
              className="absolute inset-0 bg-gradient-to-b from-[#0F2240]/40 via-transparent to-[#0F2240]/40"
            />
          </div>

          {/* Lower-third band — the hero copy sits on a slim, opaque navy strip
              pinned to the bottom of the hero, stacked directly on top of the
              quick-links bar, so the video stays unobstructed above. The
              backing is solid on purpose: axe can't resolve a contrast ratio
              for text over a <video>, so every line needs an opaque surface. */}
          <div className="relative z-10 mt-auto w-full border-t-2 border-school-gold bg-[#0F2240]">
            <div className="mx-auto flex max-w-[1400px] flex-col gap-3 px-6 py-3.5 md:px-10 md:py-4 lg:flex-row lg:items-center lg:justify-between lg:gap-8">
              <div className="min-w-0">
                {/* Eyebrow badge stays in the accessibility tree only. */}
                <p className="sr-only">Now Accepting Enrollments for 2026–2027</p>

                <h1 className="font-heading text-xl font-extrabold leading-tight tracking-tight text-white md:text-2xl lg:text-3xl">
                  <span className="whitespace-nowrap">
                    Great{' '}
                    <span className="text-school-gold italic font-light">Expectations.</span>
                  </span>
                </h1>

                <span className="sr-only">Our Vision</span>
                <p className="mt-0.5 text-xs font-semibold text-school-gold md:text-sm">
                  Empowering the students of today for the possibilities of tomorrow.
                </p>
              </div>

              <div className="grid grid-cols-2 gap-2 sm:flex sm:items-center sm:gap-3 lg:shrink-0">
                <a
                  href="#journey"
                  className="group inline-flex items-center justify-center gap-3 rounded-full bg-school-gold px-3 py-2.5 text-xs font-bold uppercase text-center tracking-[0.06em] text-school-blue transition-colors duration-300 hover:bg-white sm:px-4 sm:tracking-[0.14em]"
                >
                  <span>Begin Your Journey</span>
                  <span className="hidden sm:inline-flex">
                    <ArrowRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-1 motion-reduce:transform-none" />
                  </span>
                </a>
                <a
                  href="#about"
                  className="inline-flex items-center justify-center gap-3 rounded-full border-2 border-white/30 px-3 py-2 text-xs font-bold uppercase text-center tracking-[0.06em] text-white transition-colors duration-300 hover:border-white hover:bg-white/10 sm:px-4 sm:tracking-[0.14em]"
                >
                  <span>Discover PS 85</span>
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links — solid bar, in flow directly beneath the band so the
              two read as one stack and can never overlap. */}
          <div className="relative z-10 w-full bg-[#1B365D] border-t border-white/8">
            <div className="max-w-5xl mx-auto flex flex-wrap lg:flex-nowrap">
              {quickLinks.map((link, i) => (
                <a
                  key={i}
                  href={link.href}
                  className="flex flex-1 basis-1/2 lg:basis-auto items-center justify-center gap-3 px-4 sm:px-6 py-3.5 md:py-5 hover:bg-white/8 text-white transition-colors group border-r border-white/8 last:border-r-0 min-w-0"
                >
                  <span className="text-school-gold group-hover:scale-110 transition-transform duration-200">{link.icon}</span>
                  <span className="font-semibold text-sm text-center">{link.label}</span>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* ==================== FLYER EVENTS ==================== */}
        <section className="py-20 md:py-24 px-6 lg:px-8" style={{ backgroundColor: '#F5EFE0' }}>
          <div className="max-w-6xl mx-auto">
            <div className="mb-12">
              <span className="text-school-goldDark font-bold tracking-[0.2em] uppercase text-xs mb-4 block">Save the Date</span>
              <h2 className="font-heading font-bold text-school-blue tracking-tight leading-[1.05]" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', maxWidth: '38rem' }}>
                Happening at<br />
                <em className="text-school-goldDark font-light not-italic">PS 85.</em>
              </h2>
            </div>

            <div className="flex flex-col gap-8">
              {flyerEvents.map((event) => (
                <div key={event.id} className="bg-school-blue rounded-3xl overflow-hidden relative">
                  <div className="absolute -right-24 -top-24 w-80 h-80 bg-school-gold/10 rounded-full blur-3xl pointer-events-none" />
                  <div className="grid md:grid-cols-2">
                    <div className="p-10 md:p-14 flex flex-col justify-center relative z-10">
                      {event.eyebrow && (
                        <span className="text-school-gold font-bold tracking-[0.2em] uppercase text-xs mb-4 block">{event.eyebrow}</span>
                      )}
                      <h3 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4 leading-tight">
                        {event.title}
                      </h3>
                      <p className="text-white/60 text-base leading-relaxed mb-6 max-w-md">
                        {event.blurb}
                      </p>
                      <div className="flex flex-col gap-3 mb-8 text-white/80 text-sm">
                        {event.details.map(({ icon, text }, i) => (
                          <div key={i} className="flex items-center gap-3">
                            <span className="text-school-gold shrink-0">{icon}</span>
                            {text}
                          </div>
                        ))}
                      </div>
                      <div className="flex flex-wrap gap-3">
                        <a
                          href={event.flyerEN.src}
                          target="_blank"
                          rel="noreferrer"
                          className="bg-school-gold text-school-blue px-6 py-3 rounded-full font-bold text-sm hover:bg-white transition-colors"
                        >
                          {event.flyerES ? 'View Flyer (English)' : 'View Flyer'}<span className="sr-only"> (opens in new window)</span>
                        </a>
                        {event.flyerES && (
                          <a
                            href={event.flyerES.src}
                            target="_blank"
                            rel="noreferrer"
                            className="bg-white/10 text-white border border-white/20 px-6 py-3 rounded-full font-bold text-sm hover:bg-white/20 transition-colors"
                          >
                            Ver Volante (Español)<span className="sr-only"> (opens in new window)</span>
                          </a>
                        )}
                        <a
                          href="/calendar"
                          className="flex items-center gap-2 text-school-gold font-bold text-sm hover:text-white transition-colors px-2"
                        >
                          Add to Calendar <ArrowRightIcon className="w-4 h-4" />
                        </a>
                      </div>
                    </div>
                    {event.flyerES ? (
                    <div className="grid grid-cols-2 gap-0.5 md:gap-1 bg-white/5 content-center">
                      {[event.flyerEN, event.flyerES].map((flyer) => (
                        <a
                          key={flyer.src}
                          href={flyer.src}
                          target="_blank"
                          rel="noreferrer"
                          className="block relative overflow-hidden group focus:outline-none focus:ring-2 focus:ring-school-gold"
                        >
                          <img
                            src={flyer.src}
                            alt={flyer.alt}
                            loading="lazy"
                            decoding="async"
                            className="block w-full aspect-[4/5] object-cover transition-transform duration-500 group-hover:scale-105"
                          />
                        </a>
                      ))}
                    </div>
                    ) : (
                    <div className="flex items-center justify-center bg-white/5 p-6 md:p-10">
                      <a
                        href={event.flyerEN.src}
                        target="_blank"
                        rel="noreferrer"
                        className="block overflow-hidden rounded-2xl group focus:outline-none focus:ring-2 focus:ring-school-gold"
                      >
                        <img
                          src={event.flyerEN.src}
                          alt={event.flyerEN.alt}
                          loading="lazy"
                          decoding="async"
                          className="block w-auto h-auto max-h-[36rem] max-w-full transition-transform duration-500 group-hover:scale-105"
                        />
                      </a>
                    </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ==================== STATS BAR ==================== */}
        <section className="bg-school-gold">
          <div className="max-w-5xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 divide-x divide-school-blue/15">
            {stats.map((s) => (
              <div key={s.label} className="py-10 px-8 text-center">
                <p className="font-heading font-bold text-school-blue" style={{ fontSize: 'clamp(2.25rem, 4vw, 3.25rem)', lineHeight: 1 }}>
                  {s.num}
                </p>
                <p className="text-school-blue mt-2 text-xs font-bold uppercase tracking-widest">{s.label}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ==================== ABOUT ==================== */}
        <section
          id="about"
          className="py-24 md:py-32 px-6 lg:px-8"
          style={{ backgroundColor: '#F5EFE0' }}
        >
          <div className="max-w-[88rem] mx-auto">

            {/* Section header */}
            <div className="mb-14">
              <span className="text-school-goldDark font-bold tracking-[0.2em] uppercase text-xs mb-4 block">About Our School</span>
              <h2 className="font-heading font-bold text-school-blue tracking-tight leading-[1.05]" style={{ fontSize: 'clamp(2.25rem, 5vw, 4rem)', maxWidth: '42rem' }}>
                More than a school —<br />
                <em className="text-school-goldDark font-light not-italic">a community built on trust.</em>
              </h2>
            </div>

            {/* Bento grid */}
            <div className="grid grid-cols-1 md:grid-cols-12 gap-5">

              {/* Main dark card */}
              <div className="md:col-span-7 bg-school-blue rounded-3xl p-10 md:p-14 relative overflow-hidden group min-h-[380px] flex flex-col justify-between">
                <div className="absolute -right-20 -top-20 w-80 h-80 bg-school-gold/12 rounded-full blur-3xl pointer-events-none" />
                <div className="absolute -left-10 bottom-0 w-60 h-60 bg-school-gold/6 rounded-full blur-2xl pointer-events-none" />
                <div className="relative z-10">
                  <div className="w-11 h-11 rounded-2xl bg-school-gold/15 flex items-center justify-center text-school-gold mb-7">
                    <AcademicCapIcon className="w-6 h-6" />
                  </div>
                  <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4 leading-tight">
                    Our Mission
                  </h3>
                  <p className="text-white/60 text-base md:text-lg leading-relaxed max-w-lg">
                    At P.S. 85, we combine a supportive environment with an unshakeable commitment to academic rigor. We plan with the end in mind, utilizing data-driven targets and deliberate practice to transform student effort into conceptual mastery. By engaging every scholar in the productive struggle of independent work and peer-to-peer discourse, we foster a growth mindset and empower students as confident, self-directed leaders of their own learning. Great Expectations spark higher aspirations.
                  </p>
                </div>
              </div>

              {/* Photo card */}
              <div className="md:col-span-5 rounded-3xl overflow-hidden relative min-h-[320px] group">
                <img
                  src="/assets/images/staff-teams/administration.jpg"
                  width={1000}
                  height={1341}
                  alt="Members of the PS 85 administration team standing together in matching “You Got This” t-shirts."
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
                  style={{ objectPosition: '50% 40%' }}
                />
                {/* Caption sits on a flat, fully opaque school-blue chip: text drawn
                    directly over a photo can never be a decidable contrast surface
                    for axe, however dark the photo is. */}
                <div className="absolute bottom-8 left-8 right-8 rounded-2xl px-5 py-4" style={{ backgroundColor: '#14274A' }}>
                  <p className="text-white font-heading font-bold text-xl leading-snug">Our Administration</p>
                  <p className="text-white/70 text-sm mt-1">Great Expectations. Every Student.</p>
                </div>
              </div>

              {/* Pull quote — full width */}
              <div
                className="md:col-span-12 rounded-3xl px-10 md:px-16 py-10 flex flex-col md:flex-row items-center gap-8 border"
                style={{ backgroundColor: '#EDE5D0', borderColor: 'rgba(197,145,50,0.2)' }}
              >
                <span className="text-school-goldDark font-heading font-bold shrink-0" style={{ fontSize: '5rem', lineHeight: 1, marginTop: '-1rem' }}>"</span>
                <blockquote className="text-xl md:text-2xl font-heading font-semibold text-school-blue italic leading-snug">
                  Great Expectations. Every Student. Every Day.
                </blockquote>
                <div className="md:ml-auto shrink-0 text-center md:text-right">
                  <p className="text-school-blue font-bold text-sm">Ms. Medina</p>
                  <p className="text-gray-600 text-xs mt-0.5">Principal, PS 85 Bronx</p>
                </div>
              </div>

              {/* Value card — Excellence */}
              <div className="md:col-span-4 bg-white rounded-3xl p-8 border border-gray-100 shadow-lg shadow-gray-200/40 flex flex-col items-center text-center hover:-translate-y-1 transition-transform duration-300">
                <div className="w-14 h-14 rounded-2xl bg-school-blue/5 flex items-center justify-center text-school-blue mb-5">
                  <AcademicCapIcon className="w-7 h-7" />
                </div>
                <h3 className="text-lg font-bold text-school-blue mb-2">Excellence</h3>
                <p className="text-gray-600 text-sm leading-relaxed">We maintain high academic standards and celebrate achievement in all forms.</p>
              </div>

              {/* Value card — Innovation */}
              <div className="md:col-span-4 bg-white rounded-3xl p-8 border border-gray-100 shadow-lg shadow-gray-200/40 flex flex-col items-center text-center hover:-translate-y-1 transition-transform duration-300">
                <div className="w-14 h-14 rounded-2xl bg-school-gold/10 flex items-center justify-center text-school-gold mb-5">
                  <SparklesIcon className="w-7 h-7" />
                </div>
                <h3 className="text-lg font-bold text-school-blue mb-2">Innovation</h3>
                <p className="text-gray-600 text-sm leading-relaxed">Embracing modern teaching methods and technology to enhance every lesson.</p>
              </div>

              {/* Value card — Community (navy) */}
              <div className="md:col-span-4 bg-school-blue rounded-3xl p-8 flex flex-col items-center text-center hover:-translate-y-1 transition-transform duration-300">
                <div className="w-14 h-14 rounded-2xl bg-white/10 flex items-center justify-center text-school-gold mb-5">
                  <UserGroupIcon className="w-7 h-7" />
                </div>
                <h3 className="text-lg font-bold text-white mb-2">Community</h3>
                <p className="text-white/50 text-sm leading-relaxed">Strong partnerships between students, families, and the Bronx community.</p>
              </div>

              {/* Location bar */}
              <div
                className="md:col-span-12 rounded-3xl px-10 py-7 flex flex-col sm:flex-row items-center justify-between gap-6"
                style={{ backgroundColor: '#E8E0CE' }}
              >
                <h3 className="text-xl font-bold text-school-blue shrink-0">Find Us in the Bronx</h3>
                <div className="flex flex-col sm:flex-row gap-6">
                  <div className="flex items-center gap-3">
                    <MapPinIcon className="w-5 h-5 text-school-gold shrink-0" />
                    <p className="text-gray-600 font-medium text-sm">2400 Marion Ave, Bronx, NY 10458</p>
                  </div>
                  <div className="flex items-center gap-3">
                    <PhoneIcon className="w-5 h-5 text-school-gold shrink-0" />
                    <p className="text-gray-600 font-medium text-sm">(718) 584-5275</p>
                  </div>
                </div>
                <a
                  href="https://maps.google.com/?q=2400+Marion+Avenue,+Bronx,+NY+10458"
                  target="_blank"
                  rel="noreferrer"
                  className="shrink-0 flex items-center gap-2 bg-school-blue text-white px-6 py-3 rounded-full font-bold text-sm hover:bg-school-gold hover:text-school-blue transition-colors"
                >
                  Get Directions<span className="sr-only"> (opens in new window)</span> <ArrowUpRightIcon className="w-4 h-4" />
                </a>
              </div>

            </div>
          </div>
        </section>

        {/* ==================== NEWS & EVENTS (dark section) ==================== */}
        <section className="bg-school-blue py-24 md:py-28">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">

            {/* Header */}
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
              <div>
                <span className="text-school-gold font-bold tracking-[0.2em] uppercase text-xs mb-3 block">Stay Informed</span>
                <h2 className="text-4xl md:text-5xl font-heading font-bold text-white">Latest from PS 85</h2>
              </div>
              <a
                href="/coming-soon"
                className="inline-flex items-center gap-2 text-school-gold font-bold text-sm border-b border-school-gold/30 pb-1 hover:border-school-gold transition-colors"
              >
                All stories <ArrowRightIcon className="w-4 h-4" />
              </a>
            </div>

            <div className="grid lg:grid-cols-12 gap-5">

              {/* Featured article */}
              {newsArticles.length > 0 && (
              <div className="lg:col-span-7 group">
                <a
                  href={newsArticles[0].href}
                  target={newsArticles[0].newTab ? '_blank' : undefined}
                  rel={newsArticles[0].newTab ? 'noopener noreferrer' : undefined}
                  className="block relative overflow-hidden rounded-3xl aspect-video mb-6"
                >
                  <img
                    src={newsArticles[0].image}
                    alt={newsArticles[0].title}
                    className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-school-blue/15 group-hover:bg-transparent transition-colors duration-300" />
                  <div className="absolute top-5 left-5">
                    <span className="px-3 py-1 rounded-full bg-school-gold text-school-blue font-bold text-xs">Featured</span>
                  </div>
                </a>
                <span className="text-white/60 text-xs font-medium uppercase tracking-wider">{newsArticles[0].date}</span>
                <h3 className="text-2xl md:text-3xl font-heading font-bold text-white group-hover:text-school-gold transition-colors mt-2 mb-3 leading-snug">
                  <a
                    href={newsArticles[0].href}
                    target={newsArticles[0].newTab ? '_blank' : undefined}
                    rel={newsArticles[0].newTab ? 'noopener noreferrer' : undefined}
                  >
                    {newsArticles[0].title}
                    {newsArticles[0].newTab && <span className="sr-only"> (opens in new window)</span>}
                  </a>
                </h3>
                <p className="text-white/70 text-base leading-relaxed">{newsArticles[0].excerpt}</p>
              </div>
              )}

              {/* Sidebar */}
              <div className={`${newsArticles.length > 0 ? 'lg:col-span-5' : 'lg:col-span-12'} flex flex-col gap-4`}>
                {newsArticles.slice(1).map((article, i) => (
                <a
                  key={i}
                  href={article.href}
                  target={article.newTab ? '_blank' : undefined}
                  rel={article.newTab ? 'noopener noreferrer' : undefined}
                  className="group flex gap-5 p-5 rounded-2xl bg-white/5 hover:bg-white/8 transition-colors border border-white/8"
                >
                  <div className="w-24 h-24 shrink-0 rounded-xl overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="flex flex-col justify-center">
                    <span className="text-xs text-school-gold font-bold uppercase tracking-wider mb-2">{article.date}</span>
                    <h4 className="text-base font-bold text-white leading-snug group-hover:text-school-gold transition-colors">
                      {article.title}
                      {article.newTab && <span className="sr-only"> (opens in new window)</span>}
                    </h4>
                    <p className="text-white/60 text-sm mt-1 line-clamp-2">{article.excerpt}</p>
                  </div>
                </a>
                ))}

                {/* Events mini-board */}
                <div className="bg-white/5 border border-white/8 rounded-2xl p-7 flex-1 flex flex-col">
                  <h3 className="text-lg font-heading font-bold text-white mb-6 flex items-center gap-3">
                    <CalendarIcon className="w-5 h-5 text-school-gold" />
                    Upcoming Events
                  </h3>
                  <div className="flex-1 flex flex-col gap-2.5">
                    {upcomingEvents.map((event) => (
                      <div key={event.id} className="rounded-xl bg-white/4 border border-white/6 px-5 py-4">
                        <span className="text-school-gold font-bold text-xs uppercase tracking-wider block mb-1">
                          {formatEventDate(event)}
                        </span>
                        <p className="text-white font-bold text-sm">{event.title}</p>
                      </div>
                    ))}
                    <a
                      href="/calendar"
                      className="text-school-gold font-bold text-sm hover:text-white transition-colors self-start mt-2"
                    >
                      View full calendar &rarr;
                    </a>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* ==================== JOURNEY / STUDENT REGISTRATION ==================== */}
        <section id="journey" className="py-24 md:py-32 px-6 lg:px-8" style={{ backgroundColor: '#F5EFE0' }}>
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-14 lg:gap-20">

              {/* Sticky left */}
              <div className="lg:sticky lg:top-28 h-max">
                <span className="text-school-goldDark font-bold tracking-[0.2em] uppercase text-xs mb-4 block">Student Registration</span>
                <h2
                  className="font-heading font-bold text-school-blue leading-[1.05] mb-6"
                  style={{ fontSize: 'clamp(2rem, 4vw, 3.5rem)' }}
                >
                  Your child's journey<br />starts right here.
                </h2>
                <p className="text-gray-600 text-base leading-relaxed mb-10 max-w-sm">
                  We believe in transparency and ease. From your first tour to the first day of school, we guide you every step of the way.
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <a
                    href="tel:+17185845275"
                    className="bg-school-blue text-white px-7 py-3.5 rounded-full font-bold text-sm text-center hover:bg-school-gold hover:text-school-blue transition-colors shadow-lg shadow-school-blue/20"
                  >
                    Call the Office
                  </a>
                  <a
                    href="mailto:IEcheva2@schools.nyc.gov?subject=Student%20Registration%20Inquiry"
                    className="bg-white text-school-blue border-2 border-school-blue/15 px-7 py-3.5 rounded-full font-bold text-sm text-center hover:border-school-blue transition-colors"
                  >
                    Send a Message
                  </a>
                </div>
              </div>

              {/* Timeline card */}
              <div className="bg-white rounded-3xl p-10 md:p-12 shadow-xl shadow-gray-200/50 border border-gray-100/80">
                <p className="text-xs font-bold text-gray-600 uppercase tracking-[0.25em] mb-8 pb-6 border-b border-gray-100">The Process</p>

                <div>
                  {enrollSteps.map(({ step, title, description }, idx) => (
                    <div key={step} className="relative pl-14 pb-9 last:pb-0 group">
                      {/* Connector line */}
                      {idx < enrollSteps.length - 1 && (
                        <div className="absolute left-[1.3rem] top-11 bottom-0 w-px bg-gray-100" />
                      )}
                      {/* Step circle */}
                      <div className="absolute left-0 top-0 w-10 h-10 rounded-full border-2 border-school-gold/40 bg-school-gold/6 flex items-center justify-center font-bold text-school-blue text-xs tracking-wider transition-all duration-200 group-hover:bg-school-gold group-hover:border-school-gold group-hover:text-white">
                        {step}
                      </div>
                      <h3 className="text-lg font-bold text-gray-900 mt-1 mb-1.5">{title}</h3>
                      <p className="text-gray-600 text-sm leading-relaxed">{description}</p>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* ==================== INSTAGRAM (dark) ==================== */}
        <InstagramSection />

      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
